import { Component, OnDestroy, Input, inject } from '@angular/core';
import { sortBy as _sortBy } from 'lodash-es';
import { Subject } from 'rxjs';
import { distinctUntilChanged, debounceTime, switchMap } from 'rxjs/operators';
import { NgbModal, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { StockListService } from '../..//services/stock-list.service';
import { collections } from '../../page-config';
import { encodeSex } from '../../utils';
import { Product } from '../../model/product';
import { Image } from '../../model/image';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgxCurrencyDirective } from 'ngx-currency';
import { AsyncPipe } from '@angular/common';
@Component({
    selector: 'app-edit-stock-item',
    templateUrl: './edit-stock-item.component.html',
    styleUrls: ['./edit-stock-item.component.scss'],
    imports: [RouterLink, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, FormsModule, NgxCurrencyDirective, NgbPopover, AsyncPipe]
})
export class EditStockItemComponent implements OnDestroy {
  stockListService = inject(StockListService);
  private modalService = inject(NgbModal);


  @Input() stockItem: Product;
  @Input() index: number;
  collections = {};
  imageSearch = '';
  statuses = ['Active', 'Discontinued', 'Needs Work', 'New', 'Pending Review'];
  galleryList = _sortBy(Object.keys(collections));
  suppliers = ['Blackman', 'Ansley', 'TJH', 'n/a'];

  changed = false;

  imageSearch$ = new Subject<string>();

  constructor() {
    this.collections = collections;
    this.imageSearch$.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      switchMap((searchText: string) => {
        console.log(`this.imageSearch = ${this.imageSearch}, searchText = ${searchText}`);
        this.imageSearch = searchText;
        return this.stockListService.fetchImages(this.imageSearch);
      })
    ).subscribe(response => {
      console.log('in imageSearch$ subscribe', response);
    });
  }

  onImageSearchChange(value: string): void {
    this.imageSearch$.next(value);
  }

  linkImageToItem(image: Image, stockItem: Product): void {
    stockItem.images = [image]; // For now, totally wipe all previous image links
    this.stockListService.saveStockItem(stockItem);
  }

  openDeleteModal(content: unknown): void {
    this.modalService.open(content);
  }

  delete(item: Product): void {
    this.stockListService.deleteStockItem(item);
  }

  clone(newItemCode: string, itemToClone: Product): void {
    const clonedItem = Product.clone(itemToClone) as unknown as Product;
    clonedItem.code = newItemCode;
    this.stockListService.createStockItem(clonedItem);
  }

  saveChanges(item: Product): void {
    const [collection, type] = item.gallery.split('-');
    item.collection = collection;
    item.type = type;
    item.sex = encodeSex(item.gents, item.ladies, item.children, item.unisex);
    this.stockListService.saveStockItem(item);
  }

  ngOnDestroy(): void {
    if(this.imageSearch$) {
      this.imageSearch$.unsubscribe();
    }
  }
}
